export const FillColorChange = 'FillColorChange';
export const OutlineColorChange = 'OutlineColorChange';
export const ToggleMapView = 'ToggleMapView'; 
export const ToggleDataView = 'ToggleDataView'; 
export const ChangeTile = 'ChangeTile'
export const GEOJsonClicked = 'GEOJSONCLICKED'
export const SearchItemClicked = 'SEARCHITEMCLICKED'
export const SearchTableItem = 'SEARCHTABLEITEM'
export const ClosestFacilityComputer = 'ClosestFacilityComputer'
export const ClosestFacilityComputerRemoveJson = 'ClosestFacilityComputerRemoveJson'
